/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import cn from 'classnames';

import Box from 'UIKit/Box';

import classes from './LoadingSkeleton.module.scss';

type LoadingSkeletonProps<T extends keyof JSX.IntrinsicElements> =
  React.ComponentProps<T> &
    Pick<
      React.ComponentProps<typeof Box>,
      'renderWhen' | 'fullWidth' | 'className' | 'style' | 'relative' | 'absolute'
    > & {
      as?: T;
      /**
       * whether skeleton should have a gradient effect while its true. By default its solid color.
       */
      animateSkeleton?: boolean;
      /**
       * Height of the skeleton
       */
      height?: React.CSSProperties['height'];
      /**
       * Width of the skeleton
       */
      width?: React.CSSProperties['width'];
      /**
       * Default is rounded.
       */
      variant?: 'circle' | 'rounded' | 'rectangle';
    };

const LoadingSkeleton = <T extends keyof JSX.IntrinsicElements>(
  props: LoadingSkeletonProps<T>
) => {
  const {
    animateSkeleton = false,
    variant = 'rounded',
    width,
    height,
    className,
    style = {},
    as = 'span',
    ...restProps
  } = props;

  return (
    <Box
      as={as}
      {...restProps}
      className={cn(
        classes.skeleton,
        {
          [classes.animateSkeleton]: animateSkeleton,
          [classes.rounded]: variant === 'rounded',
          [classes.circle]: variant === 'circle',
          [classes.rectangle]: variant === 'rectangle',
        },
        className
      )}
      style={{ width, height, ...style }}
    />
  );
};

export type { LoadingSkeletonProps };
export { LoadingSkeleton };
